import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FolderComponent } from './pages/folder/folder.component';
import { LoginComponent } from './pages/login/login.component';
import { NotFoundComponent } from './pages/not-found/not-found.component';
import { OrganizationsComponent } from './pages/organizations/organizations.component';
import { ResourcegroupComponent } from './pages/resourcegroup/resourcegroup.component';
import { CreateFolderDialogComponent } from './dialogs/create-folder-dialog/create-folder-dialog.component';
import { CreateInstanceDialogComponent } from './dialogs/create-instance-dialog/create-instance-dialog.component';
import { CreateOrganizationDialogComponent } from './dialogs/create-organization-dialog/create-organization-dialog.component';
import { CreateResourceGroupDialogComponent } from './dialogs/create-resource-group-dialog/create-resource-group-dialog.component';
import { DeleteConfirmationDialogComponent } from './dialogs/delete-confirmation-dialog/delete-confirmation-dialog.component';
import { MoveResourceDialogComponent } from './dialogs/move-resource-dialog/move-resource-dialog.component';
import {MoveFailedErrorMessageDialogComponent} from "./dialogs/./move-failed-error-message-dialog/move-failed-error-message-dialog.component";
import {ReconcileFailedErrorMessageDialogComponent} from "./dialogs/reconcile-failed-error-message-dialog/reconcile-failed-error-message-dialog.component";
import { AddLabelsAndAnnotationsComponent } from './dialogs/shared/add-labels-and-annotations/add-labels-and-annotations.component';
import { CoreModule } from '../../core/core.module';
import { SharedModule } from '../../shared/shared.module';
import {
    BarModule,
    BusyIndicatorModule,
    ButtonModule,
    CheckboxModule,
    ComboboxModule,
    FdDatetimeModule,
    DynamicPageModule,
    FileUploaderModule,
    FlexibleColumnLayoutModule,
    FormControlModule,
    FormInputMessageGroupModule,
    FormLabelModule,
    FormMessageModule,
    IconModule,
    InlineHelpModule,
    LinkModule,
    ListModule,
    MenuModule,
    ObjectStatusModule,
    PanelModule,
    PopoverModule, RadioModule,
    SegmentedButtonModule,
    SelectModule,
    TableModule,
    TabsModule,
    TextModule,
    TitleModule,
    ToolbarModule, DatePickerModule, FormItemModule, MessageStripModule
} from "@fundamental-ngx/core";
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ResourceContentComponent } from './misc/resource-content/resource-content.component';
import { OrganizationContentComponent } from './misc/organization-content/organization-content.component';
import { ContentDetailsComponent } from './misc/content-details/content-details.component';
import { DetailsComponent } from './misc/content-details/sections/details/details.component';
import { DetailsRowComponent } from './misc/content-details/sections/details/details-row/details-row.component';
import { IndicesGridComponent } from './misc/content-details/sections/details/indices-grid/indices-grid.component';
import { RouterModule } from '@angular/router';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CreateGenericResourceDialogComponent } from './dialogs/create-generic-resource-dialog/create-generic-resource-dialog.component';
import { FormlyModule } from '@ngx-formly/core';
import {
    DynamicPageHeaderComponent,
    PlatformComboboxModule
} from '@fundamental-ngx/platform';
import { DetailsTableComponent } from './misc/content-details/sections/details/details-table/details-table.component';
import {DetailsTableHeaderComponent} from "./misc/content-details/sections/details/details-table-header/details-table-header.component";
import { RuntimePoliciesTableComponent } from './misc/content-details/sections/policies/runtime-policies-table/runtime-policies-table.component';
import {RtdTypeResourcesTableComponent } from "./misc/content-details/sections/rtd-type-resources/rtd-type-resources-table/rtd-type-resources-table.component";
import { ConstraintsDialogComponent } from '../../shared/components/constraints-dialog/constraints-dialog.component';
import { ConstraintNotificationComponent } from './dialogs/constraint-notification/constraint-notification.component';
import { NestedValuePipe } from "../../shared/pipes/nested-value/nested-value.pipe";
import { StatusesTableComponent } from './misc/content-details/sections/details/statuses-table/statuses-table.component';

import {
    UnifiedCreateApplicationDialogComponent
} from "./dialogs/unified-create-application-dialog/unified-create-application-dialog.component";
import {
    UnifiedStepSetupComponent
} from "./dialogs/unified-create-application-dialog/unified-step-setup/unified-step-setup.component";
import {
    UnifiedStepReviewComponent
} from "./dialogs/unified-create-application-dialog/unified-step-review/unified-step-review.component";
import {
    UnifiedCreationFinishedDialogComponent
} from "./dialogs/unified-create-application-dialog/unified-creation-finished-dialog/unified-creation-finished-dialog.component";
import {
    UnifiedReviewRowComponent
} from "./dialogs/unified-create-application-dialog/unified-step-review/unified-review-row/unified-review-row.component";
import {
    UnifiedCreationFinishedYamlConfirmationDialogComponent
} from "./dialogs/unified-create-application-dialog/unified-creation-finished-yaml-confirmation-dialog/unified-creation-finished-yaml-confirmation-dialog.component";
import { UnifiedDownloadFinishedDialogComponent } from './dialogs/unified-create-application-dialog/unified-download-finished-dialog/unified-download-finished-dialog.component';
import {
    MoveResourceStatueDialogComponent
} from "./dialogs/move-resource-status-dialog/move-resource-status-dialog.component";
import {
    MoveResourceConfirmationDialogComponent
} from "./dialogs/move-resource-confirmation-dialog/move-resource-confirmation-dialog.component";
import {
    CantAccessPathComponent
} from "./misc/content-details/sections/rtd-type-resources/cant-access-path/cant-access-path.component";
import {
    ReadAccessGrantedDialogComponent
} from "./dialogs/read-access-granted-dialog/read-access-granted-dialog.component";
import {
    DeleteFolderWithDataDialogComponent
} from "./dialogs/delete-folder-with-data-dialog/delete-folder-with-data-dialog.component";
import {
    HasResourcesDeletionFailedDialogComponent
} from "./dialogs/has-resources-deletion-failed-dialog/has-resources-deletion-failed-dialog.component";
import {ResourceHasContentComponent} from "./dialogs/resource-has-content-dialog/resource-has-content-dialog.component";
import {
    CreateGenericResourcesResultComponent
} from "./dialogs/create-generic-resources-result/create-generic-resources-result.component";
import {
    ConfirmOverwriteYamlContentComponent
} from "./dialogs/confirm-overwrite-yaml-content/confirm-overwrite-yaml-content.component";
import {
    UnifiedCreateSuiteDialogComponent
} from "./dialogs/unified-create-suite-dialog/unified-create-suite-dialog.component";
import {
    UnifiedSuiteStepSetupComponent
} from "./dialogs/unified-create-suite-dialog/unified-suite-step-setup/unified-suite-step-setup.component";
import {
    UnifiedSuiteStepReviewComponent
} from "./dialogs/unified-create-suite-dialog/unified-suite-step-review/unified-suite-step-review.component";
import {
    UnifiedSuiteCreationFinishedDialogComponent
} from "./dialogs/unified-create-suite-dialog/unified-suite-creation-finished-dialog/unified-suite-creation-finished-dialog.component";

import {
    OidcLoginDialogComponent
} from "./dialogs/oidc-login-dialog/oidc-login-dialog.component";
import {
    UnifiedStepBeginComponent
} from "./dialogs/unified-create-application-dialog/unified-step-begin/unified-step-begin.component";
import {FaIconComponent} from "@fortawesome/angular-fontawesome";
@NgModule({
    providers: [
        NestedValuePipe
    ],
    declarations: [
        FolderComponent,
        LoginComponent,
        NotFoundComponent,
        OrganizationsComponent,
        ResourcegroupComponent,
        CreateFolderDialogComponent,
        CreateInstanceDialogComponent,
        CreateOrganizationDialogComponent,
        CreateResourceGroupDialogComponent,
        //CreateSecretDialogComponent,
        DeleteConfirmationDialogComponent,
        MoveResourceConfirmationDialogComponent,
        MoveResourceDialogComponent,
        MoveResourceStatueDialogComponent,
        MoveFailedErrorMessageDialogComponent,
        ReconcileFailedErrorMessageDialogComponent,
        AddLabelsAndAnnotationsComponent,
        ResourceContentComponent,
        OrganizationContentComponent,
        ContentDetailsComponent,
        DetailsComponent,
        DetailsRowComponent,
        IndicesGridComponent,
        CreateGenericResourceDialogComponent,
        DetailsTableHeaderComponent,
        DetailsTableComponent,
        RuntimePoliciesTableComponent,
        RtdTypeResourcesTableComponent,
        ConstraintsDialogComponent,
        ConstraintNotificationComponent,
        UnifiedReviewRowComponent,
        StatusesTableComponent,
        UnifiedCreateApplicationDialogComponent,
        UnifiedStepSetupComponent,
        UnifiedStepReviewComponent,
        UnifiedCreationFinishedDialogComponent,
        UnifiedCreationFinishedYamlConfirmationDialogComponent,
        UnifiedDownloadFinishedDialogComponent,
        UnifiedCreateSuiteDialogComponent,
        UnifiedSuiteStepSetupComponent,
        UnifiedSuiteStepReviewComponent,
        UnifiedSuiteCreationFinishedDialogComponent,
        CantAccessPathComponent,
        ReadAccessGrantedDialogComponent,
        DeleteFolderWithDataDialogComponent,
        HasResourcesDeletionFailedDialogComponent,
        ResourceHasContentComponent,
        CreateGenericResourcesResultComponent,
        ConfirmOverwriteYamlContentComponent,
        OidcLoginDialogComponent,
        UnifiedStepBeginComponent
    ],
    imports: [
        CommonModule,
        CoreModule,
        SharedModule,
        BrowserAnimationsModule,
        ListModule,
        PopoverModule,
        ButtonModule,
        ToolbarModule,
        BarModule,
        DynamicPageModule,
        MenuModule,
        CheckboxModule,
        FormMessageModule,
        FormInputMessageGroupModule,
        FormControlModule,
        ReactiveFormsModule,
        FormsModule,
        FormLabelModule,
        FileUploaderModule,
        ComboboxModule,
        TableModule,
        InlineHelpModule,
        RouterModule,
        LinkModule,
        IconModule,
        BusyIndicatorModule,
        FlexibleColumnLayoutModule,
        SelectModule,
        TabsModule,
        TitleModule,
        TextModule,
        ObjectStatusModule,
        SegmentedButtonModule,
        FormlyModule,
        PlatformComboboxModule,
        PanelModule,
        RadioModule,
        FdDatetimeModule,
        DatePickerModule,
        FormItemModule,
        DynamicPageHeaderComponent,
        MessageStripModule,
        FaIconComponent
    ],
    exports: [
        FolderComponent,
        LoginComponent,
        NotFoundComponent,
        OrganizationsComponent,
        ResourcegroupComponent,
        CreateFolderDialogComponent,
        CreateInstanceDialogComponent,
        CreateOrganizationDialogComponent,
        CreateResourceGroupDialogComponent,
        DeleteConfirmationDialogComponent,
        MoveResourceConfirmationDialogComponent,
        MoveResourceDialogComponent,
        MoveResourceStatueDialogComponent,
        MoveFailedErrorMessageDialogComponent,
        ReconcileFailedErrorMessageDialogComponent,
        AddLabelsAndAnnotationsComponent,
        ResourceContentComponent,
        OrganizationContentComponent,
        ContentDetailsComponent,
        DetailsComponent,
        DetailsRowComponent,
        IndicesGridComponent,
        DeleteFolderWithDataDialogComponent,
        HasResourcesDeletionFailedDialogComponent,
        ResourceHasContentComponent
    ],
})
export class OrganizationsModule {}
